export default __webpack_public_path__ + "static/media/closet5-before2-1920w.635e3175.webp";